module.exports = __webpack_public_path__ + "img/0xbcf39f0edda668c58371e519af37ca705f2bfcbd.fbc8900a.png";